import preventDirectServerAccess from 'helpers/preventDirectServerAccess'; // polyfill webpack require.ensure

if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};
export var GiftingRoute = function GiftingRoute() {
  return {
    path: '/gifts',
    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function (require) {
        callback(null, {
          component: require('./Landing').Landing
        });
      }, 'gifts');
    },
    getChildRoutes: function getChildRoutes(location, callback) {
      var onEnter = preventDirectServerAccess('/gifts/purchase');

      require.ensure([], function (require) {
        callback(null, [{
          path: 'purchase',
          component: require('./PurchaseContainer').PurchaseContainer
        }, {
          path: 'purchase/payment',
          component: require('./PaymentContainer').PaymentContainer,
          onEnter: onEnter
        }, {
          path: 'purchase/confirmation',
          component: require('./ConfirmationContainer').ConfirmationContainer,
          onEnter: onEnter
        }]);
      }, 'gifts');
    }
  };
};